const ALLOWED_BOOK_CODE_CHARACTERS = /^[A-Z0-9]+$/;
const CLAIM_SKIPPED_PREFIX = "home-twice:claim-offer-skipped:";

type LocalStorageLike = Pick<Storage, "getItem" | "setItem">;

/** Normalize case and the optional spaces/dashes used when reading a printed code. */
export function normalizeBookCode(value: string): string {
  const normalized = value.trim().toUpperCase().replace(/[\s-]+/g, "");
  return ALLOWED_BOOK_CODE_CHARACTERS.test(normalized) ? normalized : "";
}

function safeLocalStorage(): LocalStorageLike | null {
  try {
    return typeof window === "undefined" ? null : window.localStorage;
  } catch {
    return null;
  }
}

/** Decide whether sign-in should offer an optional code claim in this browser. */
export function getClaimOfferDestination(returnPath: string, userId: string, storage = safeLocalStorage()): string {
  try {
    return storage?.getItem(`${CLAIM_SKIPPED_PREFIX}${userId}`) === "1"
      ? returnPath
      : `/claim?next=${encodeURIComponent(returnPath)}`;
  } catch {
    return `/claim?next=${encodeURIComponent(returnPath)}`;
  }
}

export function rememberClaimOfferSkipped(userId: string, storage = safeLocalStorage()): void {
  try {
    storage?.setItem(`${CLAIM_SKIPPED_PREFIX}${userId}`, "1");
  } catch {
    // If storage is unavailable, the offer may be shown again on the next login.
  }
}
